import { CoApplicantPipe } from '@hb/modules/global';
import { QuestionKey } from '@hb/modules/global/global.constants';
import { AmountFormControl } from '@hb/domain';
import { SustainabilityStoreService } from '@hb/modules/property/sustainability/sustainability-store.service';
import { AnalyticsService } from '@hb/services/analytics/analytics.service';
import { AdditionalInfoComponent } from '@hb/modules/global/additional-info';
import { NextButtonComponent } from '@hb/modules/global/button';
import { GLOBAL_STORE, GlobalInjectComponent, QUESTION_KEY } from '@hb/modules/global/abstract-global-inject.component';

import { Component, inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ApContentModule } from '@ap/content';
import { ApRadioModule } from '@ap/radio';
import { ApAmountInputComponent } from '@ap/input/amount';

@Component({
    selector: 'sustainability-amount',
    templateUrl: './sustainability-amount.component.html',
    standalone: true,
    imports: [
        ApContentModule,
        FormsModule,
        ReactiveFormsModule,
        ApRadioModule,
        ApAmountInputComponent,
        AdditionalInfoComponent,
        CoApplicantPipe,
        NextButtonComponent
    ],
    providers: [
        { provide: GLOBAL_STORE, useExisting: SustainabilityStoreService },
        { provide: QUESTION_KEY, useValue: QuestionKey.SUSTAINABILITY_AMOUNT }
    ]
})
export class SustainabilityAmountComponent extends GlobalInjectComponent<SustainabilityStoreService> implements OnInit {
    private readonly analyticsService = inject(AnalyticsService);
    protected readonly store = inject(SustainabilityStoreService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.mainApplicantControl = new AmountFormControl<string>(
            this.analyticsService,
            this.store.getSustainability()?.amount.toString(),
            this.questionKey
        );
        this.mainApplicantControl.onUpdate().subscribe((amount: string) => {
            this.store.setSustainability(amount);
        });
    }
}
